import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { Snackbar } from "@nokia-csf-uxr/ccfk";
import { SnackbarContent } from "@nokia-csf-uxr/ccfk/Snackbar";
import { RootState } from "Store/mainStore";
import { setSnackMessage as setSnackMessageSetter } from "Store/general/auth";


const SnackBar = () => {
    const dispatch = useDispatch();
    // Selectors
    const authSelector = useSelector((state: RootState) => state.authSlice);
    const messages = useMemo(
        () => _.cloneDeep(authSelector.system?.stack?.snack) || [],
        [authSelector.system?.stack?.snack]
    );
    // Set component state or props as needed
    const [open, setOpen] = useState(messages && messages.length > 0);
    const [snackMessage, setSnackMessage] = useState(undefined);
    // close on 'escape key'
    useEffect(() => {
        const onEsc = (e) => {
            if (e.key === 'Escape') {
                handleCloseMessage();
            }
        };
        window.addEventListener('keydown', onEsc);
        return () => {
            window.removeEventListener('keydown', onEsc);
        };
    }, []);

    useEffect(() => {
        // Check if there are messages to display
        if(messages && messages.length > 0) {
           setOpen(true);
           setSnackMessage({key:`snak-message-${new Date().getTime()}`,text:messages[0] });
        }
        else {
            setOpen(false);
            setSnackMessage(undefined);
        }        
    }, [messages]);

    const handleCloseMessage = () => {
        setOpen(false);
        // Clear the snack message after closing
        setSnackMessage(undefined);
        // Remove the first message from the stack and set it as the current snack message
        const updatedMessages = _.cloneDeep(messages);
        if (updatedMessages && updatedMessages.length > 0) {
            updatedMessages.shift();
            dispatch(setSnackMessageSetter({ key: 'update_snack', value: updatedMessages }));
        }
        else {
            // Call the reset action to clear the stack
            dispatch(setSnackMessageSetter('reset_snack'));
        }
    }
    return (
        <>
            {snackMessage && (
                <Snackbar
                    key={snackMessage.key}
                    open={open}
                    onClose={handleCloseMessage}
                    onExited={handleCloseMessage}
                    role="alert"
                >
                    <SnackbarContent>{snackMessage.text}</SnackbarContent>
                </Snackbar>
            )}
        </>
    );
}

export default SnackBar;